import { AccordionSummary } from '@eversports/react-components/primitives/Accordion'
import React from 'react'

import { StoredCreditCard } from '../../typings/Payment'

import NewCreditCard from './NewCreditCard'
import PaymentMethodExpansionPanel from './PaymentMethodExpansionPanel'
import PaymentMethodExpansionPanelDetails from './PaymentMethodExpansionPanelDetails'
import PaymentMethodExpansionPanelHeader from './PaymentMethodExpansionPanelHeader'
import StoredCreditCards from './StoredCreditCards'

interface Props {
  storedCreditCards: Array<StoredCreditCard>
}

const CreditCardPayment = ({ storedCreditCards }: Props) => {
  const hasStoredCreditCards = storedCreditCards && storedCreditCards.length > 0

  return (
    <PaymentMethodExpansionPanel>
      <AccordionSummary>
        <PaymentMethodExpansionPanelHeader paymentOption="pay-with-credit-card" />
      </AccordionSummary>
      <PaymentMethodExpansionPanelDetails>
        {hasStoredCreditCards && <StoredCreditCards creditCards={storedCreditCards} />}
        <NewCreditCard hasStoredCreditCards={hasStoredCreditCards} />
      </PaymentMethodExpansionPanelDetails>
    </PaymentMethodExpansionPanel>
  )
}

export default React.memo(CreditCardPayment)
